import { FormattedMessage } from 'react-intl';

import { EngineOilPreConditionsAndFeedback } from '@/features/diagnostics/sidebar/EngineOilPreConditionsAndFeedback';
import { Criticality, FillLevelMeasurements, Product } from '@/generated/fleetAggregationServiceTypes';
import { getIconClassesForCriticality } from '@/utils/criticalityMappings';
import { isEngineOilTypeDid, isEngineOilTypeV2 } from '@/utils/engineOilUtils';

type OverviewRowProps = {
    criticality: Criticality;
    count?: number;
    engineOil?: FillLevelMeasurements;
    product?: Product;
    statusMessageId?: string;
};

export const OverviewRow = ({ criticality, count, engineOil, product, statusMessageId }: OverviewRowProps) => {
    const showEngineOilReadingPreconditions = isEngineOilTypeDid(engineOil?.type) || isEngineOilTypeV2(engineOil?.type);

    const getTextClassesForCriticality = (criticalLevel: Criticality) => {
        switch (criticalLevel) {
            case Criticality.Normal:
                return 'text-uppercase';
            case Criticality.Unknown:
                return 'text-color-gray text-lowercase';
            default:
                return '';
        }
    };

    return (
        <>
            <tr>
                <td className="padding-15" style={{ borderTop: 'none' }}>
                    <div className={`display-flex ${criticality === Criticality.Normal ? 'justify-content-between' : ''}`}>
                        <div>
                            <span className={`${getIconClassesForCriticality(criticality, 'show')} margin-right-10`} />
                            <span className={criticality === Criticality.Unknown ? 'text-bold text-color-gray' : ''}>{count !== undefined && `${count} `}</span>

                            <span className={`${getTextClassesForCriticality(criticality)}`}>
                                <FormattedMessage id={statusMessageId ?? `intl-msg:fleetstatus.diagnostics.criticality.${criticality}`} />
                            </span>
                        </div>

                        {showEngineOilReadingPreconditions && engineOil?.type && (
                            <EngineOilPreConditionsAndFeedback engineOilType={engineOil?.type} engineOilPreconditions={engineOil?.engine_oil_preconditions} product={product} />
                        )}
                    </div>
                </td>
            </tr>
        </>
    );
};
